function ClinicVO(id, name, regon, nip, headquartersAddress, correspondenceAddress, individualPracticeDoctor, phone, email,
                  fax, comment, doctors, headquarters, branches, toBeVerified, offices) {
    this.id = id;
    this.name = name;
    this.regon = regon;
    this.nip = nip;
    this.phone = phone;
    this.email = email;
    this.fax = fax;
    this.comment = comment;

    this.headquartersAddress = headquartersAddress ? headquartersAddress : new AddressVO();
    this.correspondenceAddress = correspondenceAddress;

    this.individualPracticeDoctor = individualPracticeDoctor;
    this.doctors = doctors;

    this.headquarters = headquarters;
    this.branches = branches;

    this.toBeVerified = toBeVerified;
    this.offices = offices;

    var _typeContext = {
        headquartersAddress : AddressVO,
        correspondenceAddress : AddressVO,
        individualPracticeDoctor : DoctorVO,
        doctors: DoctorVO,
        headquarters: ClinicVO,
        branches: ClinicVO,
        offices: OfficeVO
    };

    this._getType = function (property) {
        if (_typeContext.hasOwnProperty(property)) {
            return _typeContext[property];
        }
        else {
            return undefined;
        }
    };

    var _mappingContext = {
    };

    this._getMapping = function (property) {
        if (_mappingContext[property]) {
            return _mappingContext[property];
        }
        else {
            return undefined;
        }
    };
}
